<template>
  <p>Resume a flow run inferred from the triggering event</p>
</template>
